import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const MERCOSURCOMMONNAME_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.MercosurCommonName.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .number('commonNameNumber', 'Entity.MercosurCommonName.CommonNameNumber')
    .required()
    .build(),
];

export const MERCOSURCOMMONNAME_CONFIG = {
  entityName: 'MercosurCommonName',
  localizationKey: 'Controlling::Entity.MercosurCommonName',
  fields: MERCOSURCOMMONNAME_FIELDS,
  permission: 'GeneralFinalProduct.MercosurCommonNames',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.FinalProduct + MENU_NAME_SUFFIX,
};
